var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"internal-layout"},[_c('div',{staticClass:"internal-layout__inner row"},[_c('div',{staticClass:"columns"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }